<div class="tender-delivery">
  <div class="tender-delivery__destination">
    <p class="tender-delivery__label">{{ 'tenders.targetDestination' | translate }}</p>
    <p class="tender-delivery__city">
      <i class="iconsax" icon-name="location"></i>
      {{
        (tender()?.delivery_city?.name | translateData) ||
          (tender()?.delivery_address | translateData) ||
          '-'
      }}
    </p>
  </div>

  @if (tender()?.delivery_address) {
    <div class="tender-delivery__field">
      <p class="tender-delivery__field-label">
        {{ 'tenders.verifiedShippingAddress' | translate }}
      </p>
      <p class="tender-delivery__field-value">
        {{ tender()?.delivery_address | translateData }}
      </p>
    </div>
  }

  @if (tender()?.delivery_city?.name) {
    <div class="tender-delivery__field">
      <p class="tender-delivery__field-label">
        {{ 'tenders.rawPayloadAddressTag' | translate }}
      </p>
      <p class="tender-delivery__field-value tender-delivery__field-value--mono">
        "{{ tender()?.delivery_city?.name | translateData }}"
      </p>
    </div>
  }
</div>
